
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import moment from 'moment';
    import { GetPrintWorld } from '@/common/js/PrintWorld';
    import DateUtils from '@/common/js/DateUtils';

    interface StockOrderBatchSearchDto {
        batchNumber?: string;
        beginTime?: Date;
        endTime?: Date;
        isPacked?: boolean;
        skipCount: number;
        maxResultCount: number;
        creationTime?: Date[];
        isPick?: boolean;
    }

    @Component({ name: "backstockorderbatch" })
    export default class BackStoreOrderBatch extends Vue {
        search: StockOrderBatchSearchDto = {
            batchNumber: '',
            beginTime: null,
            endTime: null,
            isPacked: null,
            skipCount: 0,
            maxResultCount: 10
        };
        showUserModal = false;
        userList: Array<{ id: number; userName: string }> = [];
        selectedUserId: number | null = null;
        currentBatchId: number | null = null;
        currentBatchNumber = '';
        modalTitle = '';

        isBox = true; // 默认分箱
        showBoxOption = false;

        // 状态管理
        loading = false;
        needCert = false;
        isLoadPrintList = false;
        isPdfData = false;

        // 使用计算属性从 Store 获取数据
        get list() {
            return this.$store.state.backStockOrderBatch.list;
        }

        get totalCount() {
            return this.$store.state.backStockOrderBatch.totalCount;
        }

        get currentPage() {
            return this.$store.state.backStockOrderBatch.currentPage;
        }

        get pageSize() {
            return this.$store.state.backStockOrderBatch.pageSize;
        }

        get storeLoading() {
            return this.$store.state.backStockOrderBatch.loading;
        }

        get combinedLoading() {
            return this.loading || this.storeLoading;
        }

        columns = [
            {
                title: '批次号',
                key: 'batchNumber',
                width: 180
            },
            {
                title: '创建时间',
                key: 'creationTime',
                width: 180,
                render: (h: any, params: any) => {
                    const timeValue = params.row.creationTime;
                    return h('span',
                        timeValue == null ? "" : DateUtils.formatLongDate(new Date(timeValue))
                    );
                }
            },
            {
                title: '创建人',
                key: 'creatorUserName',
                width: 100
            },
            {
                title: '打包状态',
                key: 'isPacked',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.isPacked ? '已打包' : '未打包');
                }
            }, {
                title: '拣货单',
                key: 'createPick',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', {
                        style: {
                            color: params.row.createPick ? '#19be6b' : '#ed4014'
                        }
                    }, params.row.createPick ? '已生成' : '未生成');
                }
            }, {
                title: '是否分箱',
                key: 'isBox',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', {
                        style: {
                        }
                    }, params.row.isBox ? '是' : '否');
                }
            }, {
                title: '是否删单',
                key: 'isDeleteOrder',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', {
                        style: {
                        }
                    }, params.row.isDeleteOrder ? '是' : '否');
                }
            },
            {
                title: '打包时间',
                key: 'packedTime',
                width: 180,
                render: (h: any, params: any) => {
                    const timeValue = params.row.packedTime;
                    return h('span',
                        timeValue == null ? "" : DateUtils.formatLongDate(new Date(timeValue))
                    );
                }
            },
            {
                title: '打包人',
                key: 'packedUserName',
                width: 100
            },
            {
                title: '订单数量',
                key: 'count',
                width: 100
            },
            {
                title: '拣货分配',
                key: 'allocateName',
                width: 100
            },
            {
                title: '操作',
                width: 120,
                render: (h: any, params: any) => {
                    return h('Dropdown', {
                        props: {
                            trigger: 'click',
                            placement: 'bottom-end'
                        },
                        on: {
                            'on-click': (name: string) => {
                                if (name === 'batchPrint') {
                                    this.batchPrint(params.row.id, params.row.batchNumber);
                                } else if (name === 'createPick') {
                                    this.createPick(params.row.id, params.row.batchNumber);
                                } else if (name === 'modifyAllocateUser') {
                                    this.modifyAllocateUser(params.row.id, params.row.batchNumber);
                                } else if (name === 'batchArriveWarehouse') {
                                    this.batchArriveWarehouse(params.row.id, params.row.batchNumber);
                                } else if (name === 'batchPack') {
                                    this.goToBatchPack(params.row);
                                } else if (name === 'cancelBatch') {
                                    this.cancelBatch(params.row.id, params.row.batchNumber);
                                } else if (name === 'printBarcode') {
                                    this.printBarcode(params.row);
                                } else if (name === 'printDetailBarcode') {
                                    this.printDetailBarcode(params.row);
                                } else if (name === 'resetBatch') {
                                    this.resetBatch(params.row.id, params.row.batchNumber);
                                }
                            }
                        }
                    }, [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            }
                        }, [
                            h('span', '操作'),
                            h('Icon', {
                                props: {
                                    type: 'ios-arrow-down'
                                }
                            })
                        ]),
                        h('DropdownMenu', {
                            slot: 'list'
                        }, [
                            h('DropdownItem', {
                                props: {
                                    name: 'batchPrint'
                                }
                            }, '批量打印'),
                            !params.row.isPacked && !params.row.createPick ? h('DropdownItem', {
                                props: {
                                    name: 'createPick'
                                }
                            }, '生成拣货单') : null,
                            //!params.row.createPick ? h('DropdownItem', {
                            //    props: {
                            //        name: 'createPick'
                            //    }
                            //}, '生成拣货单') : null,
                            !params.row.isPacked && params.row.createPick ? h('DropdownItem', {
                                props: {
                                    name: 'modifyAllocateUser'
                                }
                            }, '修改分配人') : null,
                            !params.row.isPacked ? h('DropdownItem', {
                                props: {
                                    name: 'batchArriveWarehouse'
                                }
                            }, '确认出仓') : null,
                            !params.row.isPacked ? h('DropdownItem', {
                                props: {
                                    name: 'batchPack'
                                }
                            }, '批次打包') : null,
                            !params.row.isPacked ? h('DropdownItem', {
                                props: {
                                    name: 'cancelBatch'
                                }
                            }, '取消批次') : null,
                            h('DropdownItem', {
                                props: {
                                    name: 'printBarcode'
                                }
                            }, '打印条形码'),
                            params.row.createPick ? h('DropdownItem', {
                                props: {
                                    name: 'printDetailBarcode'
                                }
                            }, '打印拣货单') : null,
                            params.row.isDeleteOrder && params.row.createPick ? h('DropdownItem', {
                                props: {
                                    name: 'resetBatch'
                                }
                            }, '重置批次') : null,
                        ])
                    ]);
                }
            }
        ];


        async printBarcode(row: any) {
            // 如果没有加载打印机列表，先加载
            if (!this.isLoadPrintList) {
                const printWorld = new GetPrintWorld();
                const json = {
                    action: "printers",
                    refresh: true,
                    defaultprn: true,
                    error: "",
                    val: {}
                };
                printWorld.CallbackOnPrinterList(this.processPrintList.bind(this));
                if (!printWorld.Act(json)) {
                    this.$Message.error(printWorld.GetLastError());
                    return false;
                }
                return false;
            }
            var pdfData = {
                barCode: row.batchNumber,
                shelfPosition: '',
                imageUrl: "",
                url: '',
                isRotate: false,
                isBox: row.isBox == true ? true : false
            };
            this.$store.commit('backStockOrderBatch/getPrint', pdfData);
            const printSelect = document.querySelector('#SelectPrint') as HTMLSelectElement;

            if (!printSelect.value) {
                this.$Message.warning("请选择指定打印机");
                return false;
            }

            if (pdfData.url && pdfData.url.length > 0) {
                var jsonsList = [];
                var printWorld = new GetPrintWorld(); //new 一个打天下对象

                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                var baseData = await this.pdfLinkToBase64(pdfData.url);
                jsons.action = "printfile";
                jsons.format = "file_base64";
                jsons.content = "data:application/pdf;base64," + baseData;

                jsons.paperlength = 15;
                jsons.paperwidth = 10;

                if (this.needCert) {
                    jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                }
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                jsonsList.push(jsons);
                printWorld.Act(jsonsList);
            }
            return true;
        }

        async printDetailBarcode(row: any) {
            if (!row.createPick) {
                this.$Message.warning("未生成拣货单，不允许打印。");
                return false;
            }
            // 如果没有加载打印机列表，先加载
            if (!this.isLoadPrintList) {
                const printWorld = new GetPrintWorld();
                const json = {
                    action: "printers",
                    refresh: true,
                    defaultprn: true,
                    error: "",
                    val: {}
                };
                printWorld.CallbackOnPrinterList(this.processPrintList.bind(this));
                if (!printWorld.Act(json)) {
                    this.$Message.error(printWorld.GetLastError());
                    return false;
                }
                return false;
            }
            const printSelect = document.querySelector('#SelectPrint') as HTMLSelectElement;

            if (!printSelect.value) {
                this.$Message.warning("请选择指定打印机");
                return false;
            }
            var allCount = Math.ceil(row.skuCount / 10);
            for (var i = 0; i < allCount; i++) {
                var pdfData = {
                    barCode: row.batchNumber,
                    currentPage: (i + 1),
                    url:'',
                };
                this.$store.commit('backStockOrderBatch/getDetailPrint', pdfData);
                if (pdfData.url && pdfData.url.length > 0) {
                    var jsonsList = [];
                    var printWorld = new GetPrintWorld(); //new 一个打天下对象

                    var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                    var baseData = await this.pdfLinkToBase64(pdfData.url);
                    jsons.action = "printfile";
                    jsons.format = "file_base64";
                    jsons.content = "data:application/pdf;base64," + baseData;

                    jsons.paperlength = 15;
                    jsons.paperwidth = 10;

                    if (this.needCert) {
                        jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                    }
                    jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                    jsonsList.push(jsons);
                    printWorld.Act(jsonsList);
                }
            }
            return true;
        }

        goToBatchPack(row: any) {
            this.$store.state.backPackingBatch.isRedirect = true;
            this.$router.push({
                name: 'backstockorderbatchpack',
                params: {
                    batchName: row.batchNumber
                }
            });
        }


        async getUserList() {
            try {
                this.userList = await this.$store.dispatch('user/getUserList', {});
                // 默认选中当前登录用户
                if (this.userList.length > 0 && abp.session.userId) {
                    const currentUser = this.userList.find(u => u.id === abp.session.userId);
                    if (currentUser) {
                        this.selectedUserId = currentUser.id;
                    }
                }
            } catch (error) {
                console.error('获取用户列表失败:', error);
            }
        }

        activated() {
        }

        deactivated() {
        }

        created() {
            this.getUserList(); // 加载用户列表

            const today = new Date();
            const tenDaysAgo = new Date();
            tenDaysAgo.setDate(today.getDate() - 10);

            // 设置默认时间范围（最近10天）
            this.search.creationTime = [tenDaysAgo, today];
            this.search.beginTime = tenDaysAgo;
            this.search.endTime = today;

            const batchNumber = this.$route.params.batchNumber;
            if (batchNumber) {
                this.search.batchNumber = batchNumber as string;
            }
            this.getList();
            this.loadPrinterList();
        }

        async createPick(batchId: number, batchNumber: string) {

            this.currentBatchId = batchId;
            this.currentBatchNumber = batchNumber;
            this.modalTitle = `为批次 ${batchNumber} 生成拣货单`;

            this.isBox = true; // 重置为默认值
            this.showBoxOption = true;

            this.showUserModal = true;


            //this.$Modal.confirm({
            //    title: '生成拣货单',
            //    content: `确认为批次 ${batchNumber} 生成拣货单吗？`,
            //    onOk: async () => {
            //        await this.$store.dispatch('backStockOrderBatch/createPick', {
            //            batchId: batchId
            //        });
            //        this.$Message.success('拣货单生成成功');
            //        this.getList(); // 刷新列表
            //    }
            //});
        }

        modifyAllocateUser(batchId: number, batchNumber: string) {
            this.currentBatchId = batchId;
            this.currentBatchNumber = batchNumber;
            this.modalTitle = `修改批次 ${batchNumber} 的分配人`;
            this.showBoxOption = false;
            this.showUserModal = true;
        }

        // 确认用户选择
        async confirmUser() {
            if (!this.selectedUserId) {
                this.$Message.warning('请选择分配用户');
                return false;
            }

            try {
                if (this.modalTitle.includes('生成拣货单')) {
                    // 调用生成拣货单接口，传入 userId
                    await this.$store.dispatch('backStockOrderBatch/createPick', {
                        batchId: this.currentBatchId,
                        userId: this.selectedUserId,
                        isBox: this.isBox 
                    });
                    this.$Message.success('拣货单生成成功');
                } else {
                    // 调用修改分配人接口
                    await this.$store.dispatch('backStockOrderBatch/setAllocateUserId', {
                        batchId: this.currentBatchId,
                        userId: this.selectedUserId
                    });
                    this.$Message.success('分配人修改成功');
                }
                this.getList(); // 刷新列表
                this.cancelUser(); // 清空状态
                return true;
            } catch (error) {
                this.$Message.error('操作失败：' + (error as any).message);
                return false;
            }
        }

        // 取消用户选择
        cancelUser() {
            this.showUserModal = false;
            this.currentBatchId = null;
            this.currentBatchNumber = '';
        }


        async getList() {
            this.loading = true;
            try {
                if (this.search.creationTime && this.search.creationTime.length === 2) {
                    this.search.beginTime = this.search.creationTime[0];
                    this.search.endTime = this.search.creationTime[1];
                } else {
                    this.search.beginTime = null;
                    this.search.endTime = null;
                }

                this.search.skipCount = (this.currentPage - 1) * this.pageSize;
                this.search.maxResultCount = this.pageSize;

                await this.$store.dispatch('backStockOrderBatch/getStockOrderBatchList', {
                    data: this.search
                });

            } finally {
                this.loading = false;
            }
        }



        //beforeRouteUpdate(to: any, from: any, next: any) {
        //    // 只有路由参数 batchNumber 发生变化时才执行
        //    if (to.params.batchNumber !== from.params.batchNumber) {
        //        const batchNumber = to.params.batchNumber;
        //        if (batchNumber) {
        //            this.search.batchNumber = batchNumber;
        //            this.$store.commit('backStockOrderBatch/setCurrentPage', 1);
        //            this.getList();
        //        }
        //    }
        //    next();
        //}

        @Watch('$route.params.batchNumber')
        onBatchNumberChange(val: string) {
            if (val && this.$store.state.backStockOrderBatch.isRedirect) {
                this.$store.state.backStockOrderBatch.isRedirect = false;
                this.search.batchNumber = val;
                this.$store.commit('backStockOrderBatch/setCurrentPage', 1);
                this.getList();
            }
        }

        searchPage() {
            this.$store.commit('backStockOrderBatch/setCurrentPage', 1);
            this.getList();
        }

        resetQuery() {
            this.search = {
                batchNumber: '',
                beginTime: null,
                endTime: null,
                isPacked: null,
                skipCount: 0,
                maxResultCount: 10,
                isPick:null
            };
            this.$store.commit('backStockOrderBatch/setCurrentPage', 1);
            this.getList();
        }

        pageChange(page: number) {
            this.$store.commit('backStockOrderBatch/setCurrentPage', page);
            this.getList();
        }

        pageSizeChange(size: number) {
            this.$store.commit('backStockOrderBatch/setPageSize', size);
            this.$store.commit('backStockOrderBatch/setCurrentPage', 1);
            this.getList();
        }

        // 确认打包
        async batchPacked(batchId: number, batchNumber: string) {
            this.$Modal.confirm({
                title: '确认打包',
                content: `确认将批次 ${batchNumber} 标记为已打包吗？此操作不可撤销。`,
                onOk: async () => {
                    await this.$store.dispatch('backStockOrderBatch/setBatchPacked', {
                        data: { id:batchId }
                    });
                    this.$Message.success('批次打包成功');
                    this.getList();
                }
            });
        }

        async batchArriveWarehouse(batchId: number, batchNumber: string) {
            this.$Modal.confirm({
                title: '确认打包',
                content: `确认将批次 ${batchNumber} 标记为已出仓吗？此操作不可撤销。`,
                onOk: async () => {
                    await this.$store.dispatch('backStockOrderBatch/setBatchArriveWarehouse', {
                        data: { id: batchId }
                    });
                    this.$Message.success('批次打包成功');
                    this.getList();
                }
            });
        }

        // 取消批次
        async cancelBatch(batchId: number, batchNumber: string) {
            this.$Modal.confirm({
                title: '取消批次',
                content: `确认取消批次 ${batchNumber} 吗？此操作将取消该批次的所有订单。`,
                onOk: async () => {
                    await this.$store.dispatch('backStockOrderBatch/cancelBatch', {
                        data: { id: batchId }
                    });
                    this.$Message.success('批次取消成功');
                    this.getList();
                }
            });
        }

        async resetBatch(batchId: number, batchNumber: string) {
            this.$Modal.confirm({
                title: '重置批次',
                content: `确认重置 ${batchNumber} 吗？此操作将删除拣货单。`,
                onOk: async () => {
                    await this.$store.dispatch('backStockOrderBatch/resetBatch', {
                        batchId: batchId
                    });
                    this.$Message.success('批次取消成功');
                    this.getList();
                }
            });
        }

        // 批量打印
        async batchPrint(batchId: number, batchNumber: string) {
            this.$Modal.confirm({
                title: '批量打印',
                content: `确认批量打印批次 ${batchNumber} 的所有订单吗？`,
                onOk: async () => {
                    // 获取批次详情
                    const detail = await this.$store.dispatch('backStockOrderBatch/getBatchDetail', {
                        data: { id: batchId }
                    });

                    if (!detail || !detail.orders || detail.orders.length === 0) {
                        this.$Message.warning('该批次没有订单可以打印');
                        return;
                    }

                    let successCount = 0;
                    let failCount = 0;

                    for (const order of detail.orders) {
                        // 添加延迟，避免打印请求过于密集
                        var result = await this.printPdf(order);

                        if (!result) {
                            break;
                        }
                    }
                }
            });
        }

        // 查看批次PDF
        async viewBatchPdf(batchId: number) {
            // 获取批次详情
            const detail = await this.$store.dispatch('backStockOrderBatch/getBatchDetail', {
                data: { batchId }
            });

            if (!detail || !detail.orders || detail.orders.length === 0) {
                this.$Message.warning('该批次没有订单');
                return;
            }

            // 默认查看第一个订单的PDF
            const firstOrder = detail.orders[0];
            const pdfData = this.getPdfUrl(firstOrder);

            if (pdfData.url) {
                window.open(pdfData.url, '_blank');
            } else {
                this.$Message.warning(`订单 ${firstOrder.orderNumber} 没有 PDF 面单`);
            }
        }

        // 获取PDF URL
        getPdfUrl(data: any): any {
            const pdfData: any = {
                pdfGuid: data.pdfGuid,
                userId: data.userId,
                orderNumber: data.orderNumber,
                pdfdata: this.isPdfData
            };

            if (this.isPdfData) {
                pdfData.infos = this.formatShelfData(data.productInfos);
                if (data.tradeNo && data.tradeNo.startsWith("68")) {
                    pdfData.heightPercentage = 100;
                } else {
                    pdfData.heightPercentage = 69;
                }
            }

            this.$store.commit('fontorder/getZDYPdfUrl', pdfData);
            return pdfData;
        }

        // 格式化货架数据
        formatShelfData(data: any[]): string {
            const totalCount = data.reduce((sum: number, item: any) => sum + item.count, 0);
            const formatTotal = (str: string) => str.padEnd(13, ' ');
            const formatShelf = (str: string) => str.padEnd(20, ' ');

            const shelfItems = data.map((item: any) =>
                formatShelf(`${item.shelfPosition}_${item.productId} * ${(item.count > 1 ? `[${item.count}]` : item.count)}`)
            );

            const output: string[] = [];
            if (shelfItems.length > 0) {
                let firstLine = formatTotal(`Total: ${totalCount}`);
                if (shelfItems.length >= 1) firstLine += shelfItems[0];
                if (shelfItems.length >= 2) firstLine += shelfItems[1];
                output.push(firstLine);
            }
            for (let i = 2; i < shelfItems.length; i += 2) {
                let line = ' '.repeat(17);
                if (shelfItems[i]) line += shelfItems[i];
                if (shelfItems[i + 1]) line += shelfItems[i + 1];
                output.push(line);
            }
            return output.join(',');
        }

        // 处理打印机列表
        processPrintList(json: any) {
            const selectPrint = document.querySelector('#SelectPrint') as HTMLSelectElement;
            selectPrint.innerHTML = '<option value="">请选择打印机</option>';
            for (const printer of json.val) {
                const option = document.createElement('option');
                option.innerHTML = printer.name;
                option.value = printer.name;
                selectPrint.appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
        }

        // 打印PDF
        async printPdf(data: any) {
            // 如果没有加载打印机列表，先加载
            if (!this.isLoadPrintList) {
                const printWorld = new GetPrintWorld();
                const json = {
                    action: "printers",
                    refresh: true,
                    defaultprn: true,
                    error: "",
                    val: {}
                };
                printWorld.CallbackOnPrinterList(this.processPrintList.bind(this));
                if (!printWorld.Act(json)) {
                    this.$Message.error(printWorld.GetLastError());
                    return false;
                }
                return false;
            }

            const pdfData = this.getPdfUrl(data);
            const printSelect = document.querySelector('#SelectPrint') as HTMLSelectElement;

            if (!printSelect.value) {
                this.$Message.warning("请选择指定打印机");
                return false;
            }

            if (!pdfData.url) {
                this.$Message.warning(`订单 ${data.orderNumber} 没有 PDF 面单`);
                return false;
            }

            const base64 = await this.pdfLinkToBase64(pdfData.url);
            const printWorld = new GetPrintWorld();
            const jsons = {
                action: "printfile",
                format: "file_base64",
                content: "data:application/pdf;base64," + base64,
                paperlength: pdfData.heightPercentage === 100 ? 140 : 15,
                paperwidth: pdfData.heightPercentage === 100 ? 100 : 10,
                cert: this.needCert ? "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf" : "",
                printer: printSelect.value
            };
            printWorld.Act(jsons);
            return true;
        }

        // PDF链接转Base64
        async pdfLinkToBase64(url: string): Promise<string> {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const arrayBuffer = await response.arrayBuffer();
                return this.arrayBufferToBase64(arrayBuffer);
            } catch (error) {
                console.error('Error fetching the PDF:', error);
                throw error;
            }
        }

        // ArrayBuffer转Base64
        arrayBufferToBase64(buffer: ArrayBuffer): string {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }

        // 加载打印机列表
        async loadPrinterList() {
            const printWorld = new GetPrintWorld();
            const json = {
                action: "printers",
                refresh: true,
                defaultprn: true,
                error: "",
                val: {}
            };
            printWorld.CallbackOnPrinterList(this.processPrintList.bind(this));
            printWorld.Act(json);
        }
    }
